
import * as z from 'zod';

export const contactFormSchema = z.object({
  name: z.string().min(1, { message: 'Name is required' }),
  lastName: z.string().min(1, { message: 'Last name is required' }),
  email: z.string().email({ message: 'Invalid email address' }).optional().or(z.literal('')),
  country: z.string().min(1, { message: 'Country is required' }),
  whatsapp: z.string().min(1, { message: 'WhatsApp number is required' }),
  language: z.string().min(1, { message: 'Language is required' }),
  message: z.string().optional(),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;
